import React from "react";
import { useDispatch } from "react-redux";

import { push } from "connected-react-router";

import { Button, Result } from "antd";
import { QuestionOutlined } from "@ant-design/icons";

function Error404Page() {
  const dispatch = useDispatch();

  return (
    <Result
      icon={<QuestionOutlined />}
      title="404"
      subTitle="Whoops! Page Not Found."
      extra={
        <Button
          type="primary"
          onClick={() => {
            dispatch(push("/"));
          }}
        >
          Back to Home
        </Button>
      }
    />
  );
}
export default Error404Page;
